import { lazy } from 'react';
import { Route } from 'react-router';

const TermsPage = lazy(() => import('../pages/MiscPages/TermsPage/TermsPage'));
const ContactUsPage = lazy(() => import('@betty/account/pages/ContactUsPage'));
const Faq = lazy(() => import('../pages/MiscPages/Faq/Faq'));
const AboutUs = lazy(() => import('../pages/MiscPages/AboutUs/AboutUs'));
const AllGamesPage = lazy(() => import('@betty/games/pages/AllGamesPage'));
const BettyStatus = lazy(
  () => import('../pages/MiscPages/BettyStatus/BettyStatus'),
);
const LevelUp = lazy(() => import('../pages/MiscPages/LevelUp/LevelUp'));
const PrivacyPolicy = lazy(
  () => import('../pages/MiscPages/PrivacyPolicy/PrivacyPolicy'),
);
const ResponsibleGaming = lazy(
  () => import('../pages/MiscPages/ResponsibleGaming/ResponsibleGaming'),
);

export const renderMiscRoutes = () => (
  <>
    <Route path="/terms" Component={TermsPage} />
    <Route path="/contact" Component={ContactUsPage} />
    <Route path="/status" Component={BettyStatus} />
    <Route path="/level-up" Component={LevelUp} />
    <Route path="/privacy" Component={PrivacyPolicy} />
    <Route path="/responsible-gaming" Component={ResponsibleGaming} />
    <Route path="/faqs" Component={Faq} />
    <Route path="/about" Component={AboutUs} />
    <Route path="/all" Component={AllGamesPage} />
  </>
);
